export default __webpack_public_path__ + "static/media/doc1.37f6806d.jpg";